import React from 'react';
import PixelBlast from './PixelBlast';

const PixelBlastBackground: React.FC = () => {
  return (
    <div 
        style={{ 
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          zIndex: -1,
          overflow: 'hidden'
        }}
      >
      <PixelBlast
        variant="triangle"
        pixelSize={4}
        color="#E4DDD7"
        patternScale={2}
        patternDensity={0.4}
        pixelSizeJitter={0}
        enableRipples={false}
        liquid={false}
        speed={0.5}
        edgeFade={0.25}
        transparent={true}
      />
    </div>
  );
};

export default PixelBlastBackground;

